import { createSlice } from '@reduxjs/toolkit';
import { store } from '../../store';
import { getLastModemSwapDisplay, setLastModemSwapDisplay } from '../../helper/storage';
import { complete as measurementComplete } from '../measurement/measurementSlice';

interface CustomerCommunicationState {
  lastModemSwapDisplay: Date | null
  lastModemSwapDialogVisible: boolean
};

const initialState: CustomerCommunicationState = {
  lastModemSwapDisplay: getLastModemSwapDisplay(),
  lastModemSwapDialogVisible: false,
};

export const customerCommunicationSlice = createSlice({
  name: 'customerCommunication',
  initialState,
  reducers: {
    showCustomerCommunicationAfterMeasurement: (state) => {
      const show =
        state.lastModemSwapDisplay == null || 
        Date.now() - state.lastModemSwapDisplay.getTime() > 2 * 24 * 3600 * 1000
      
      return {
        ...state,
        lastModemSwapDialogVisible: show,
      }
    },
    closeDialog: (state) => {
      const currentTime = new Date();
      setLastModemSwapDisplay(currentTime);
      return {
        ...state,
        lastModemSwapDisplay: currentTime,
        lastModemSwapDialogVisible: false
      }
    }
  },
  extraReducers: (builder) => {
    builder.addCase(measurementComplete, (state, action) => {
      setTimeout(() => {
        store.dispatch(showCustomerCommunicationAfterMeasurement());
      }, 1500);

    })
  }
});

export const { showCustomerCommunicationAfterMeasurement,  closeDialog } = customerCommunicationSlice.actions;
export default customerCommunicationSlice;